import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { SgoModulo } from '../models/sgo-modulo.model';

@Injectable({
  providedIn: 'root',
})
export class SgoModuloService extends BaseService<SgoModulo> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/sgo-modulos';
  }

}
